import Vue from 'vue';

import AudioPlayer from './AudioPlayer';
import Avatar from './Avatar';
import Card from './Card';
import CardContainer from './CardContainer';
import ConfirmDialog from './ConfirmDialog';
import FavoriteButton from './FavoriteButton';
import FileItem from './FileItem';
import FileUpload from './FileUpload';
import ListTransition from './ListTransition';
import LogoPageContainer from './LogoPageContainer';
import Message from './Message';
import NotFound from './NotFound';
import OverlayLoading from './OverlayLoading';
import Resizer from './Resizer';
import Rating from './Rating';
import RatingField from './RatingField';
import Slider from './Slider';
import VTooltip from './VTooltip';


Vue.component('app-audio-player', AudioPlayer);
Vue.component('app-avatar', Avatar);
Vue.component('app-card', Card);
Vue.component('app-card-container', CardContainer);
Vue.component('app-confirm-dialog', ConfirmDialog);
Vue.component('app-favorite-button', FavoriteButton);
Vue.component('app-file-item', FileItem);
Vue.component('app-file-upload', FileUpload);
Vue.component('app-list-transition', ListTransition);
Vue.component('app-logo-page-container', LogoPageContainer);
Vue.component('app-message', Message);
Vue.component('app-notfound', NotFound);
Vue.component('app-overlay-loading', OverlayLoading);
Vue.component('app-resizer', Resizer);
Vue.component('app-rating', Rating);
Vue.component('app-rating-field', RatingField);
Vue.component('app-slider', Slider);
Vue.component('v-tooltip', VTooltip);
